import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suivi-portefeuille',
  templateUrl: './suivi-portefeuille.component.html',
  styleUrls: ['./suivi-portefeuille.component.scss']
})
export class SuiviPortefeuilleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
